export const VUEX_FILTERBAR_ITEMSDISPLAY_SORTORDER_SET = 'VUEX_FILTERBAR_ITEMSDISPLAY_SORTORDER_SET'
